import { BaseAction } from 'src/app/store/models/base-action';

export abstract class PayloadAction<T> extends BaseAction {

  constructor(public payload: T) {
    super();
  }

}
